import { CONSUMER_LOAN_LIMITS } from "shared/CalculatorLimits";
import { CONSUMER_LOAN_PURPOSES } from "shared/CalculatorReasons";
import { getAmountField } from "web_myplann/Calculators/Forms/getAmountField";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

export const getConsumerLoanFormSchema = (t: TranslateFunction) =>
	z.object({
		loanValue: getAmountField(t, {
			min: CONSUMER_LOAN_LIMITS.loanMin,
			max: CONSUMER_LOAN_LIMITS.loanMax,
		}),
		purpose: z.enum(CONSUMER_LOAN_PURPOSES, {
			message: t(Resources.Form.Validations.required),
		}),
		years: z.number(),
	});
